"use strict";
exports.__esModule = true;
exports.GENERIC_PAYMENT_FAILURE = void 0;
exports.GENERIC_PAYMENT_FAILURE = {
    RENT_TRACKER: {
        MAIN_TEXT: 'Your 1st payment failed ',
        SUB_TEXT: 'There was an issue with your card or bank. You can make your payment now, or we’ll continue trying every {{retryHours}} until {{retryDay}}',
        CTA: 'Pay now'
    },
    PAY_NOW: {
        HEADER: 'Make your 1st payment',
        BODY: 'We’ll submit your rent to your property after this payment is completed.'
    },
    SERVICE_ISSUE_SCREEN: {
        BOLD_MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to an issue with your card or bank.',
        MAIN_TEXT: ' ',
        SUB_TEXT: 'You can make your payment now, or we’ll continue trying every {{retryHours}} until we notify you otherwise. The deadline to make your payment is {{retryDay}}.',
        HEADER: 'Your 1st payment failed',
        PRIMARY_CTA_TEXT: 'Pay now',
        SECONDARY_CTA_TEXT: 'Update card'
    }
};
